import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import InputGroupV2 from '../InputGroupV2';
import CreatableSelect from 'react-select/creatable';
import { getReactSelectStyles } from '../reactSelectTheme';

const CreatableMultiSelectV2 = ({
  label,
  onChange,
  placement,
  title,
  useTooltip,
  required,
  options,
  defaultValue,
}) => {
  const theme = useTheme();
  const selectStyles = useMemo(() => getReactSelectStyles(theme), [theme]);

  const DropdownIndicator = () => (
    <ArrowDropDownIcon sx={{ color: 'text.secondary' }} />
  );
  const IndicatorSeparator = () => '';

  return (
    <InputGroupV2
      label={label}
      placement={placement}
      title={title}
      useTooltip={useTooltip}
      isRequired={required}
    >
      <CreatableSelect
        components={{ DropdownIndicator, IndicatorSeparator }}
        isMulti
        styles={selectStyles}
        options={options}
        onChange={onChange}
        value={defaultValue}
        placeholder="Selecione..."
        noOptionsMessage={() => 'Sem opções'}
        formatCreateLabel={(inputText) => `Criar "${inputText}"`}
        menuPlacement="auto"
      />
    </InputGroupV2>
  );
};

CreatableMultiSelectV2.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  defaultValue: PropTypes.array.isRequired,
  placement: PropTypes.string,
  title: PropTypes.string,
  useTooltip: PropTypes.bool,
  required: PropTypes.bool,
};

CreatableMultiSelectV2.defaultProps = {
  placement: '',
  title: '',
  useTooltip: false,
  required: false,
};

export default CreatableMultiSelectV2;
